(async () => {
  const el = document.getElementById('shame-mark-index')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/shame-mark/index.vue'),
    },
  ]

  await clientRender({ components })
})()
